import { render, staticRenderFns } from "./CustomerManage.vue?vue&type=template&id=c4676a70&scoped=true"
import script from "./CustomerManage.vue?vue&type=script&lang=js"
export * from "./CustomerManage.vue?vue&type=script&lang=js"
import style0 from "./CustomerManage.vue?vue&type=style&index=0&id=c4676a70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4676a70",
  null
  
)

export default component.exports